import { Icon, IconProps } from '@/shared/ui/Icon/Icon';
import { IconNames } from '@/shared/ui/Icon/Icon.types';

import styles from './Icons.module.scss';

const ICON_VIEW_BOXES: Record<string, { w: number; h: number }> = {
  doc3d2: { w: 26, h: 26 },
  eyeWithLine: { w: 25, h: 25 },
  upperJaw: { w: 26, h: 26 },
  lowerJaw: { w: 26, h: 26 },
  tooth3d: { w: 21, h: 21 },
  anatomy3d: { w: 21, h: 21 },
  implant: { w: 21, h: 21 },
  implant3d: { w: 112, h: 112 },
  ortho3d: { w: 113, h: 113 },
  opacity: { w: 26, h: 26 },
  brush: { w: 26, h: 26 },
  cursor: { w: 20, h: 25 },
  permute: { w: 27, h: 26 },
  studies: { w: 27, h: 26 },
  rule: { w: 33, h: 32 },
  biteOFTeeth: { w: 19, h: 30 },
  prev: { w: 26, h: 22 },
  next: { w: 26, h: 22 },
  arrow2: { w: 8, h: 9 },
  arrowUp2: { w: 8, h: 5 },
  arrowDown2: { w: 8, h: 5 },
  model3d: { w: 100, h: 100 },
  ios3d: { w: 100, h: 100 },
  cbct3d: { w: 100, h: 100 },
  alert: { w: 24, h: 24 },
  share: { w: 32, h: 32 },
  time: { w: 24, h: 24 },
  sharpness: { w: 64, h: 64 },
  burger: { w: 28, h: 28 },
  angle: { w: 28, h: 28 },
  minus: { w: 28, h: 28 },
  camera: { w: 28, h: 28 },
  cat: { w: 24, h: 24 },
  world: { w: 32, h: 32 },
  user: { w: 24, h: 24 },
  users: { w: 65, h: 64 },
  boldPlus: { w: 32, h: 32 },
  boldShare: { w: 32, h: 32 },
  info2: { w: 20, h: 20 },
  orderScribe: { w: 80, h: 80 },
  file: { w: 32, h: 36 },
  folder: { w: 36, h: 29 },
};

const ALL_ICONS: IconNames[] = [
  'comment2',
  'comment2Filled',
  'commentAi',
  'commentAiFilled',
  'cube',
  'comment',
  'movepawFilled',
  'movepaw',
  'invert',
  'expand',
  'zoom',
  'erase',
  'pen',
  'scribe',
  'download',
  'brightness',
  'split',
  'ruler',
  'rotate',
  'back',
  'print',
  'check',
  'close',
  'arrow',
  'plus',
  'move',
  'move2',
  'delete',
  'cbct',
  'ioxray',
  'pano',
  'photo',
  'ios',
  'doc',
  'dots',
  'arrowDown',
  'arrowUp2',
  'arrowDown2',
  'star',
  'starFilled',
  'play',
  'playFilled',
  'pause',
  'stop',
  'search',
  'searchFilled',
  'bell',
  'bellFilled',
  'moon',
  'moonFilled',
  'sun',
  'sunFilled',
  'faceWindow',
  'faceAxial',
  'faceSagittal',
  'calendar',
  'archive',
  'eye',
  'eyeClosed',
  'eyeFilled',
  'eyeClosedFilled',
  'tiles',
  'list',
  'study',
  'doc3d',
  'model3d',
  'ios3d',
  'photo3d',
  'pano3d',
  'cbct3d',
  'ortho3d',
  'info',
  'alert',
  'copy',
  'share',
  'time',
  'burger',
  'sharpness',
  'cursor',
  'permute',
  'studies',
  'rule',
  'biteOFTeeth',
  'prev',
  'next',
  'eyeWithLine',
  'upperJaw',
  'lowerJaw',
  'tooth3d',
  'anatomy3d',
  'implant3d',
  'implant',
  'opacity',
  'brush',
  'doc3d2',
  'angle',
  'arrow2',
  'minus',
  'camera',
  'cat',
  'world',
  'users',
  'boldPlus',
  'boldShare',
  'user',
  'info2',
  'CEMarking',
  'MDMarking',
  'cbctNew',
  'rewind',
  'toothnum',
  'attention',
  'filter',
  'file',
  'folder',
  'turn',
  'orderScribe',
  'crop',
  'mirror',
  'zoomOut',
  'sparkles',
];

const getIconSize = (name: IconNames): Pick<IconProps, 'width' | 'height'> => {
  const custom = ICON_VIEW_BOXES[name];

  if (custom) {
    return { width: custom.w, height: custom.h };
  }

  return { width: 48, height: 48 };
};

export const Icons = () => (
  <div className={styles.container}>
    <h2 className={styles.title}>Icons ({ALL_ICONS.length})</h2>

    <div className={styles.grid}>
      {ALL_ICONS.map((name) => {
        const { width, height } = getIconSize(name);

        return (
          <div key={name} className={styles.card}>
            <div className={styles.iconWrapper}>
              <Icon name={name} width={width} height={height} />
            </div>
            <span className={styles.label}>{name}</span>
            <span className={styles.size}>
              {width}x{height}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
